import { useLabels } from '@/lib/terminology'

export function HelpPage() {
  const labels = useLabels()

  const helpTopics = [
    {
      title: 'Getting Started',
      description: `Learn the basics of managing your ${labels.guests.toLowerCase()}`,
      icon: '🚀',
    },
    {
      title: `${labels.pipeline} Management`,
      description: `Track ${labels.guests.toLowerCase()} through your production workflow`,
      icon: '📊',
    },
    {
      title: labels.schedule,
      description: 'Coordinate recording sessions and air dates',
      icon: '📅',
    },
    {
      title: 'Integrations',
      description: 'Connect your favorite tools and services',
      icon: '🔗',
    },
    {
      title: 'Team Collaboration',
      description: 'Work together with your production team',
      icon: '👥',
    },
    {
      title: 'Billing & Account',
      description: 'Manage your subscription and account settings',
      icon: '💳',
    },
  ]

  return (
    <div className="p-6 max-w-4xl">
      <div className="mb-6">
        <h1 className="text-2xl font-semibold text-zinc-900 dark:text-zinc-100">Help & Support</h1>
      </div>

      {/* Search */}
      <div className="mb-8">
        <input
          type="search"
          placeholder="Search for help..."
          className="w-full px-4 py-3 rounded-xl border border-zinc-300 dark:border-zinc-700 bg-white dark:bg-zinc-900 text-zinc-900 dark:text-zinc-100 focus:outline-none focus:ring-2 focus:ring-primary-500"
        />
      </div>

      {/* Help Topics */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-8">
        {helpTopics.map((topic) => (
          <button
            key={topic.title}
            className="bg-white dark:bg-zinc-900 rounded-xl border border-zinc-200 dark:border-zinc-800 p-6 text-left hover:border-primary-500 transition-colors"
          >
            <span className="text-2xl mb-3 block">{topic.icon}</span>
            <h3 className="font-medium text-zinc-900 dark:text-zinc-100">{topic.title}</h3>
            <p className="text-sm text-zinc-500 mt-1">{topic.description}</p>
          </button>
        ))}
      </div>

      {/* Contact */}
      <div className="bg-zinc-100 dark:bg-zinc-800/50 rounded-xl p-6 text-center">
        <h2 className="text-lg font-semibold text-zinc-900 dark:text-zinc-100 mb-2">
          Need more help?
        </h2>
        <p className="text-zinc-500 mb-4">Our support team is here to assist you</p>
        <button className="px-4 py-2 rounded-lg bg-primary-500 hover:bg-primary-600 text-white font-medium transition-colors">
          Contact Support
        </button>
      </div>
    </div>
  )
}
